import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import app_it from '../translations/it/app.json';
import app_en from '../translations/en/app.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
        it: {
           app: app_it
        },
        en: {
            app: app_en
        }
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "app",
    ns: ["app"],

    interpolation: {
      escapeValue: false
    },
	
    debug: true
  });

export default i18n;